import React from 'react';
import { Option } from '../../../types/cards';
import './MultiChoiceTileContent.css';

interface TileSelectorProps {
    options: Option[];
    onSelect: (value: string) => void;
    selectedValues: string[];
    step: any;
}

export const MultiChoiceTileContent: React.FC<TileSelectorProps> = ({ options, onSelect, selectedValues, step }) => {
    const handleSelect = (optionId: string) => {
        onSelect(optionId);
    };

    return (
        <div className="tile-selector">
            <div className="tile-selector__options">
                {options.map(option => {
                    const isSelected = selectedValues.includes(option.id);
                    const imageUrl = option.image?.formats.small?.url ||
                                   option.image?.formats.thumbnail?.url ||
                                   option.image?.url;

                    return (
                        <button
                            key={option.id}
                            className={`tile-selector__option ${isSelected ? 'tile-selector__option--selected' : ''}`}
                            onClick={() => handleSelect(option.id)}
                        >
                            {imageUrl && (
                                <div className="tile-selector__image-container">
                                    <div className="tile-selector__gradient-bg" />
                                    <img
                                        src={imageUrl}
                                        alt={option.title || option.text}
                                        className="tile-selector__image"
                                    />
                                </div>
                            )}
                            <span className="tile-selector__label">{option.text}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
